import { ISubscriptionService, SubscriptionServiceImpl } from './subscription.service';

export * from './subscription.model';

export const SubscriptionService: ISubscriptionService = new SubscriptionServiceImpl();